export function langEnablementInit() {
    if (window.SFRA.SitePreferences.languageExclusionList) {
        let elementsWithReplacement = document.querySelectorAll('.font-family--cartier-logos');
        [].forEach.call(elementsWithReplacement, function(elementWithReplacement) {
            var siblingTextNode = elementWithReplacement.nextSibling;
            if (siblingTextNode.nodeType == Node.TEXT_NODE && siblingTextNode.textContent.trim() !== '') {
                let spanElement = document.createElement('span');
                siblingTextNode.parentNode.insertBefore(spanElement, siblingTextNode);
                spanElement.appendChild(siblingTextNode);
            }
        });

        var allElements = document.getElementsByTagName('*');
        const wordsAndPhrasesToUpperCaseString = window.SFRA.SitePreferences.languageExclusionList,
            wordsAndPhrasesToUpperCase = JSON.parse(wordsAndPhrasesToUpperCaseString);

        [].forEach.call(allElements, function(element) {
            var computedStyle = window.getComputedStyle(element);
            if (computedStyle.getPropertyValue('text-transform') === 'uppercase') {
                if (element && element.hasChildNodes()) {
                    let innermostChild = element;

                    while (innermostChild.hasChildNodes()) {
                        innermostChild = innermostChild.firstChild;
                    }

                    if (innermostChild.nodeType === Node.TEXT_NODE) {
                        let textContent = innermostChild.textContent;

                        // Replace words and phrases with their uppercase versions
                        wordsAndPhrasesToUpperCase.forEach(word => {
                            const regex = new RegExp(`\\b${word}\\b`, 'gi'); // Use word boundaries and case-insensitive matching
                            textContent = textContent.replace(regex, word.toLocaleUpperCase());
                        });

                        innermostChild.textContent = textContent;
                    }
                }
            }
        });
    }
}
